import React from 'react';
import Main from './Routes/Main';

function App() {
  return (
    <>
      <Main />
    </>
  );
}

export default App;
